/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: d357c60f3b29
 */

import * as z from "zod";
import { EventType, EventType$zodSchema } from "./eventtype.js";

export type CreateTriggerRequest = { uri: string; event_type: EventType };

export const CreateTriggerRequest$zodSchema: z.ZodType<CreateTriggerRequest> = z
  .object({
    event_type: EventType$zodSchema.describe("The type of notification event."),
    uri: z.string().describe(
      "The URL that will receive the notification response.",
    ),
  });
